export default "__VITE_PUBLIC_ASSET__f0e84704__"